import { SwgyHeaderKeysList } from "@swiggy-private/checkout-types";
import { BOOLEAN_AS_STRING } from "@swiggy-private/payment-types";

import { isMROFlow } from "@checkout-core/helpers/MROCart";
import { isQuickCheckoutFlow } from "@checkout-core/helpers/QuickCheckout";
import { GlobalHeaderState } from "@checkout-core/utils/Headers";

/**
 * Shared cart-flow columns for New Relic.
 *
 * - Quick Checkout events: `isQuickCheckoutFlow` + `xCartType`
 * - MRO events: `isMroFlow` + `xCartType`
 * - Shared enrichment (place/confirm/transition): include both flow flags + `xCartType`
 */
export const getXCartType = (): string => {
    return (GlobalHeaderState.getHeader(SwgyHeaderKeysList.xCartType) || "").toLowerCase();
};

export const getQuickCheckoutNRAttrs = (): {
    isQuickCheckoutFlow: BOOLEAN_AS_STRING;
    xCartType: string;
} => ({
    isQuickCheckoutFlow: isQuickCheckoutFlow() ? BOOLEAN_AS_STRING.TRUE : BOOLEAN_AS_STRING.FALSE,
    xCartType: getXCartType(),
});

export const getMroFlowNRAttrs = (): {
    isMroFlow: BOOLEAN_AS_STRING;
    xCartType: string;
} => ({
    isMroFlow: isMROFlow() ? BOOLEAN_AS_STRING.TRUE : BOOLEAN_AS_STRING.FALSE,
    xCartType: getXCartType(),
});

/** Both flow flags + xCartType — use when enriching shared order/transition tables. */
export const getCheckoutFlowNRAttrs = (): {
    isQuickCheckoutFlow: BOOLEAN_AS_STRING;
    isMroFlow: BOOLEAN_AS_STRING;
    xCartType: string;
} => ({
    ...getQuickCheckoutNRAttrs(),
    ...getMroFlowNRAttrs(),
});
